import { dispatchAvoEvent } from "avo/index";

interface interactedLoginViaOtpProps {
    clickedOn: string; 
    otpEntered: boolean;
    interactionDetails?: string;
    invitationSource: string;
    referrerPage: string;
};

const sendEventUsingAvo = (props: any = {}) => {
    const initParams = {
        //@ts-ignore
        klassGrade: window.KLASS_GRADE?.code ?? null, //@ts-ignore
        currentGrade: window.KLASS_GRADE?.code ?? null, //@ts-ignore
        subjectCode: window.KLASS_DETAIL?.id ? "Math" : '', //@ts-ignore
        klass: window.KLASS_DETAIL,
    };

    dispatchAvoEvent(props, initParams);
};

const viewedLoginViaOtp = ({ invitationSource, referrerPage, fromPage } : { invitationSource: string; referrerPage: string; fromPage: string }) => {
    trackEventsForGuests("Viewed Login via OTP by Classroom Linked Parent", { 
        "custom_user_type": "guest_ptl_parent",
        "Invitation Source": invitationSource || localStorage.getItem("invitationSource"),
        "Referrer Page": referrerPage || localStorage.getItem("referrerPage"),
        "From Page": fromPage || "Home access setup page"
      }, { send_mixpanel: true }
    );
}

const interactedLoginViaOtp = ({ clickedOn = "", otpEntered, interactionDetails = "", invitationSource, referrerPage }: interactedLoginViaOtpProps) => {
    trackEventsForGuests("Interacted Login via OTP by Classroom Linked Parent", { 
        "custom_user_type": "guest_ptl_parent",
        "Clicked On" : clickedOn,
        "OTP Entered": otpEntered,
        "Interaction Details": interactionDetails,
        "Invitation Source": invitationSource || localStorage.getItem("invitationSource"),
        "Referrer Page": referrerPage || localStorage.getItem("referrerPage")
      }, { send_mixpanel: true }
    );
}

const ptlParentLoginAttemptedEvent = ({ invitationSource, referrerPage } : { invitationSource: string; referrerPage: string; }) => {
    trackEventsForGuests("PTL Parent Login Attempted", { 
        "custom_user_type": "guest_ptl_parent",
        "Invitation Source": invitationSource || localStorage.getItem("invitationSource"),
        "Referrer Page": referrerPage || localStorage.getItem("referrerPage"),
        "Login Method": "Verification code",
        "Is Email Updated" : "0"
      }, { send_mixpanel: true }
    );
}


const referralParentLoginEvents = {
    interactedLoginViaOtp,
    viewedLoginViaOtp,
    ptlParentLoginAttemptedEvent
}

export default referralParentLoginEvents